export const BOX_MANUAL_FOLDER_ENABLED = 'manual_folder_enabled'
